import { inject, Injectable } from '@angular/core';
import { FacebookLogin } from '@capacitor-community/facebook-login';
import { AppTrackingTransparency, AppTrackingStatus } from 'capacitor-plugin-app-tracking-transparency';
import { PLATFORM_TOKEN, PlatformProvider } from '../tokens';
import { ENV_CONFIG, EnvConfig } from '../env';
import { Log, Logger } from '../shared-services';

@Injectable({ providedIn: 'root' })
export class MetaService {
  private readonly env: EnvConfig = inject(ENV_CONFIG);
  private readonly platformProvider: PlatformProvider = inject(PLATFORM_TOKEN);
  private readonly logger: Logger = inject(Logger);

  async initialize(): Promise<void> {
    if (!this.platformProvider.isNativeRun || !this.env.facebookAppId) {
      this.logger.log(Log.Startup, { message: 'MetaService init SKIPPED' });
      return;
    }

    try {
      await FacebookLogin.initialize({
        appId: this.env.facebookAppId,
        autoLogAppEvents: true
      });
      this.logger.log(Log.Startup, { message: 'MetaService initialized' });

      await this.syncAdvertiserTrackingWithATT();
    } catch (error) {
      this.logger.log(Log.Startup, { message: `MetaService init failed: ${(error as Error).message}` });
    }
  }

  private async syncAdvertiserTrackingWithATT(): Promise<void> {
    if (!this.platformProvider.isiOS) {
      return;
    }

    try {
      const { status } = await AppTrackingTransparency.getStatus();
      const enabled: boolean = (status as AppTrackingStatus) === 'authorized';
      await FacebookLogin.setAdvertiserTrackingEnabled({ enabled });
      await FacebookLogin.setAdvertiserIDCollectionEnabled({ enabled });
      this.logger.log(Log.Startup, {
        message: `MetaService advertiser tracking set to ${enabled} (ATT: ${status})`
      });
    } catch (error) {
      this.logger.log(Log.Startup, {
        message: `MetaService advertiser tracking sync failed: ${(error as Error).message}`
      });
    }
  }
}
